import { Component, HostBinding, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ComponentColors, ComponentSizes } from '@pc/common';

@Component({
  selector: 'pc-responsive-abstract-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './responsive-abstract-card.component.html',
  styleUrl: './responsive-abstract-card.component.scss'
})
export class ResponsiveAbstractCardComponent {
  @Input() size: ComponentSizes = 'medium';

  @Input() color?: ComponentColors = 'primary';

  @HostBinding('class') get class(): string {
    return `color--${this.color} size--${this.size}`;
  }
}
